const experienceData = [
  {
    company: "Company Name",
    role: "Fashion Position",
    period: "2023 - 2025",
    description:
      "Experience in fashion management, customer experience, styling and brand communication."
  },

  {
    company: "Company Name",
    role: "Fashion Position",
    period: "2021 - 2023",
    description:
      "Developing knowledge of trends, visual presentation and client relationships."
  }
];

export default experienceData;